<form>
    <app-form-section [formGroup]="reminderForm">
        <app-form-row-header [title]="'FEATURES.AGREEMENTS.GROUP_TITLE_REMINDER' | translate" icon="notifications" />
        <div class="form">
            <app-form-row>
                <app-form-group>
                    <label for="recipients"
                        >{{ 'FEATURES.AGREEMENTS.RECIPIENT' | translate }}
                        <span
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.REMINDER_RECIPIENTS' | translate"
                            class="material-symbols-rounded"
                            aria-hidden="true"
                        >
                            help
                        </span>
                    </label>
                    <app-multi-select
                        [showToggleAll]="true"
                        [searchable]="true"
                        [showAllText]="false"
                        [items]="recipients$ | async"
                        formControlName="recipients"
                        [placeholder]="
                            'SELECT.SELECT_WITH_LABEL'
                                | translate
                                    : {
                                          label: 'FEATURES.AGREEMENTS.RECIPIENT' | translate
                                      }
                        "
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row *ngIf="f.recipients.value?.length > 0">
                <app-form-group>
                    <label for="numOfReminders">{{ 'FEATURES.AGREEMENTS.NUMBER_OF_REMINDERS' | translate }}</label>
                    <app-dropdown [items]="reminders" formControlName="numOfReminders" />
                    <span class="info" *ngIf="getReminderDates().length"
                        >{{ 'FEATURES.AGREEMENTS.SEND_REMINDER_INFO' | translate }}
                        <ul>
                            <li *ngFor="let date of getReminderDates()" [ngClass]="{ red: isDateInPast(date) }">
                                {{ date | date: 'yyyy-MM-dd' }}
                            </li>
                        </ul>
                        <button type="button" class="calendar-link" *ngIf="!isCreateMode" (click)="openCalendarModal()">
                            <span class="material-symbols-rounded" aria-hidden="true">calendar_add_on</span>
                            {{ 'FEATURES.AGREEMENTS.ADD_TO_CALENDAR' | translate }}
                        </button>
                        <label for="addToCalendar" *ngIf="isCreateMode">
                            <app-checkbox
                                *ngIf="isCreateMode"
                                formControlName="addToCalendar"
                                [text]="'FEATURES.AGREEMENTS.ADD_TO_CALENDAR' | translate"
                            ></app-checkbox>
                            <span
                                class="material-symbols-rounded"
                                aria-hidden="true"
                                [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.ADD_TO_CALENDAR' | translate"
                            >
                                help
                            </span>
                        </label>
                    </span>
                </app-form-group>
                <app-form-group
                    ><label
                        for="reminderPeriod"
                        title="{{ 'FEATURES.AGREEMENTS.HELP_INFO.REMINDER_PERIOD' | translate }}"
                        >{{ 'FEATURES.AGREEMENTS.REMINDER_PERIOD' | translate }}</label
                    >
                    <app-dropdown [items]="reminderPeriods" formControlName="reminderPeriod" />
                    <span class="info">{{ lastDateForNotice }}</span>
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.reminderPeriod"
                        languageKey="FEATURES.AGREEMENTS.REMINDER_PERIOD"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row *ngIf="f.recipients.value?.length > 0">
                <app-form-group>
                    <label for="escalatedRecipients">{{
                        'FEATURES.AGREEMENTS.ESCALATED_RECIPIENTS' | translate
                    }}</label>
                    <app-multi-select
                        [showToggleAll]="true"
                        [searchable]="true"
                        [showAllText]="false"
                        [items]="recipients$ | async"
                        formControlName="escalatedRecipients"
                        [placeholder]="
                            'SELECT.SELECT_WITH_LABEL'
                                | translate
                                    : {
                                          label: 'FEATURES.AGREEMENTS.RECIPIENT' | translate
                                      }
                        "
                    />
                </app-form-group>
            </app-form-row>
        </div>
    </app-form-section>
</form>
